<template>
    <div class="contest-container" v-loading="loading">
        <el-row  justify="space-between" :gutter="0">
            <el-col :xs="2" :sm="3" :md="4" :lg="5" :xl="6">
                <div style="height: 1px; width: 100%">
                </div>
            </el-col>
            <el-col :xs="20" :sm="18" :md="16" :lg="14" :xl="12">
                <div class="contest" align="center">
                    <div class="image-container" v-show="!loading">
                        <div class="outline">

                        </div>
                        <div @click="join">
                            <img :src="img" class="img" :class="{'expired':expired}" height="200">
                            <div class="join">
                                <span v-if="expired || started">
                                    <span v-if="expired">Evento finalizado</span>
                                    <span v-else>Evento en curso</span>
                                </span>
                                <span v-else>
                                    PARTICIPAR
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="title">{{name}}</div>
                    <div class="short-desc">{{shortDesc}}</div>

                    <div class="participants" align="right">
                        <span>{{participants}}</span>
                        <span v-if="maxParticipants != undefined"> de {{maxParticipants}}</span>
                         participantes
                    </div>

                    <div class="types" align="left">
                        <span v-for="type in types" :key="type.id" :style="getStyle(type)">
                            {{type.name}}
                        </span>
                    </div>

                    <div class="imgs" v-show="images != undefined && images.length > 0">
                        <el-carousel trigger="click" height="300px" type="card" arrow="always">
                            <el-carousel-item v-for="item in images" :key="item">
                                <img :src="item.url" class="img" width="100%" @click="openModalImage(item)" />
                                <div v-if="item.showDefaultDesc">{{item.name}}</div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>

                    <div class="body" v-html="desc">
                    </div>
                    <div style="width: 100%">
                        <el-button class="join" @click="join" type="primary" :disabled="expired || started" plain>
                            <span v-if="expired || started">
                                <span v-if="expired">Evento finalizado</span>
                                <span v-else>Evento en curso</span>
                            </span>
                            <span v-else>
                                Participar
                            </span>
                        </el-button>
                    </div>

                    <div class="footer">
                        <div class="date" align="right">
                            Creado el {{date}}
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="2" :sm="3" :md="4" :lg="5" :xl="6">
                <div style="height: 1px; width: 100%">
                </div>
            </el-col>
        </el-row>

        <el-dialog title=" " :visible.sync="modalImg.open">
            <div v-if="modalImg.item != undefined">
                <img :src="modalImg.item.url" class="img" width="100%" />
                <div v-if="modalImg.showDefaultDesc">{{modalImg.item.name}}</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import axios from 'axios';

export default {
    name: 'Contest',
    props: {
        type: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            modalImg: {
                item: undefined,
                open: false
            },
            id: 2,
            name: "Torneo VERSUS",
            desc: "Juntate con tu amigo y compitan en este Torneo 2v2 por skins!",
            prizeTitle: "Los ganadores se llevan",
            participants: 0,
            maxParticipants: 10,
            //prize: "Ganadores primera etapa: Skins de Heimerdinger Veraniego. 1º y 2º puesto: Vayne Flor Espiritual",
            prizes: [
                {
                    title: "Ganadores primera etapa",
                    desc: "Skins de Heimerdinger Veraniego"
                },
                {
                    title: "1º y 2º puesto",
                    desc: "Vayne Flor Espiritual"
                }
            ],
            date: "29/07/2020",
            expired: false,
            started: false,
            img: 'http://lolarg.driconmax.com.ar/img/Torneo%202v2.jpg',
            images: [
                'http://lolarg.driconmax.com.ar/img/carreralunar/Carrera Lunar 1.jpg',
                'http://lolarg.driconmax.com.ar/img/carreralunar/Carrera Lunar 2.jpg',
                'http://lolarg.driconmax.com.ar/img/carreralunar/Carrera Lunar 3.jpg',
                'http://lolarg.driconmax.com.ar/img/carreralunar/Carrera Lunar 4.jpg'
            ],
            types: [
                {
                    id: 1,
                    name: "SORTEO",
                    color: "#CC0000"
                },
                {
                    id: 2,
                    name: "TORNEO",
                    color: "#AA00AA"
                },
                {
                    id: 3,
                    name: "VERSUS",
                    color: "#AAAA22"
                }
            ]
        }
    },
    beforeMount() {
        this.loading = true;
        this.clearData();
        axios({
			method: 'POST',
			url: '/server/contests.php?action=getid',
			data: {
                id: this.$route.params.id
            }
		}).then((response) => {
			if(response.data.error != 0){
				this.$notify.error({
					title: 'Error',
					message: response.data.message,
					offset: 115
				});
			} else {
                //response.data.data;
                this.id = response.data.data.id;
                this.name = response.data.data.name;
                this.shortDesc = response.data.data.shortDesc;
                this.desc = decodeURI(response.data.data.desc);
                this.prizeTitle = response.data.data.prizeTitle;
                this.participantType = response.data.data.participantType;
                this.maxParticipants = response.data.data.maxParticipants;
                this.date = response.data.data.date;
                this.startDate = response.data.data.startDate;
                this.endDate = response.data.data.endDate;
                this.img = response.data.data.img;
                this.types = response.data.data.types;
                this.images = response.data.data.images;
                this.status = response.data.data.status;
                this.expired = response.data.data.expired;
                this.started = response.data.data.started;
                this.template = response.data.data.template;
			}
		})
		.catch(this.catchAxios)
		.then(() => {
			this.loading = false;
		});
    },
    methods: {
        clearData(){
            this.id = -1;
            this.name = "";
            this.shortDesc = "";
            this.desc = "";
            this.prizeTitle = "";
            this.participantType = "";
            this.maxParticipants = "";
            this.date = "";
            this.startDate = "";
            this.endDate = "";
            this.img = "";
            this.types = [];
            this.images = [];
            this.status = "";
            this.template = -1;
        },
        getStyle(type){
            var obj = {};
            if(type.color != undefined && type.color != "") obj.color = type.color;
            return obj;
        },

        join(){
            if(!this.expired && !this.started){
                this.$router.push({ name: 'join-contest', params: { id: this.$route.params.id } })
            }
        },

        goToDiv(ref){
            console.log(this.$refs[ref]);
        },

        openModalImage(img){
            this.modalImg.item = img;
            this.modalImg.open = true;
        }
    },
    computed: {
        
    },
    
}
</script>

<style scoped>
    .contest-container {
        padding-top: 130px;
    }

    .contest {
        background-color: #222933CC;
        border-color: gray;
        border-left: solid 1px;
        border-right: solid 1px;
        border-top: solid 1px;
        border-bottom: solid 1px;
        position: relative;
        padding-top: 100px;
        padding-bottom: 30px;
        margin-bottom: 50px;
    }    

	.image-container {
        height: 200px;
        width: 200px;
        border-top-left-radius: 50%;
        border-top-right-radius: 50%;
        border-top: 0;
        border-left: 0;
        border-right: 0;
        border-bottom: 0;
        position: absolute;
        left: calc(50% - 100px);
        top: -100px;
    }

    .image-container .outline {
        position: absolute;
        height: 100px;
        left: -1px;
        top: -1px;
        border-top-left-radius: 10000px;
        border-top-right-radius: 10000px;
        border: 1px solid #fff;
        border-bottom: 0;
    }

    .image-container > div {
        height: 200px;
        width: 200px;
        border-radius: 50%;
        transform: scale(1);
        transition: border-bottom-left-radius .4s ease-in-out, border-bottom-right-radius .4s ease-in-out;
        overflow: hidden;
        cursor: pointer;
    }

    .image-container > div > img {
        transform: scale(1);
        transition: transform .4s ease-in-out, filter .4s ease-in-out;
    }

    .image-container div .join {
        width: 100%;
        opacity: 0;
        font-weight: bold;
        position: absolute;
        text-align: center;
        top: calc(50% - 0.5em);
        transition: opacity .4s ease-in-out .3s;
    }
    
    .image-container > div:hover .join {
        opacity: 1;
    }

    .image-container > div:hover {
        border-bottom-left-radius: 0%;
        border-bottom-right-radius: 0%;
    }

    .image-container > div:hover > img {
        transform: scale(1.1);
        filter: blur(2px) grayscale(60%);
    }

    .img {

    }

    .img.expired {
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
    }
    
    .title {
        text-transform: uppercase;
        letter-spacing: 3px;
        font-weight: lighter;
        font-size: 22px;
        margin-top: 35px;
        color: #ffb70a;
    }

    .short-desc {
        font-size: 12px;
        color: #ffd777;
    }

    .participants {
        position: absolute;
        top: 0px;
        left: 0px;
        font-weight: bolder;
        font-size: 10px;
        padding: 10px;
    }

    .types {
        position: absolute;
        text-transform: uppercase;
        top: 0px;
        right: 0px;
        font-weight: bolder;
        font-size: 10px;
        padding: 10px;
    }

    .types>span:nth-child(1):before {
        content: "";
        border-left: none !important;
        padding-right: 3px;
    }

    .types>span:nth-child(n+1):before {
        content: "";
        border-left: 1px solid #DDD;
        padding-right: 3px;
    }

    .imgs {
        padding: 40px;
    }

    .body {
        text-align: justify;
        padding: 40px;
    }

    .join {
        width: 60%;
    }

    .footer {
        position: absolute;
        bottom: 0px;
        right: 0px;
    }

    .date {
        font-size: 10px;
        padding: 5px;
        color: gray;
    }
</style>